import React, { useState } from "react";
import { Form , Button , Radio ,Row ,Col , DatePicker , Typography , Table} from 'antd';
import { getRangeOptions , getPaginationDetails, getDefaultPageSize} from './reports.module';
import { fetchWebTicketSalesSheet} from './../../actions/reports.action';
import { getAPIDateFormat , convertDateStringToDate ,getLocalDate , getLocalDateAndTime, getDateTimeFormat} from './../../utils/date.utils';
import { isValid, isValidArray, isValidNumber } from "../../utils/utilities";
import { roundNumber } from './../../utils/math.utils';
import { Printer } from './../../components/custom-components/custom-component';
import * as XLSX from 'xlsx';
import { dafidyUserCheck } from "../../utils/constant";
import { loadingAction } from "../../actions/loading-actions";
import { useDispatch } from "react-redux";

const {Text} =Typography;

const { RangePicker } = DatePicker;
let allowedMaxDaysRange=31;
let xs=24, sm=24, md=12 , lg=12 , xl=12 , xxl=12;

const getFilteredOptions=(confirmedTickets,cancelledTickets)=>{
    let confirmedTicketOptions = {
        operatorOptions:[],
        addedOperators:[],
        scheduleOptions:[],
        addedSchedules:[]
    } , cancelledTicketOptions = {
        operatorOptions:[],
        addedOperators:[],
        scheduleOptions:[],
        addedSchedules:[]
    };
    if(isValidArray(confirmedTickets)&&confirmedTickets.length>0){
        confirmedTickets.forEach((element)=>{
            if(confirmedTicketOptions.addedOperators.indexOf(element.operator_name) === -1){
                confirmedTicketOptions.addedOperators.push(element.operator_name);
                confirmedTicketOptions.operatorOptions.push({
                    text:element.operator_name,
                    value:element.operator_name
                }); 
            }

            if(confirmedTicketOptions.addedSchedules.indexOf(element.description) === -1){
                confirmedTicketOptions.addedSchedules.push(element.description);
                confirmedTicketOptions.scheduleOptions.push({
                    text:element.description,
                    value:element.description
                }); 
            }
        })
    }

    if(isValidArray(cancelledTickets)&&cancelledTickets.length>0){
        cancelledTickets.forEach((element)=>{
            if(cancelledTicketOptions.addedOperators.indexOf(element.operator_name) === -1){
                cancelledTicketOptions.addedOperators.push(element.operator_name);
                cancelledTicketOptions.operatorOptions.push({
                    text:element.operator_name,
                    value:element.operator_name
                }); 
            }

            if(cancelledTicketOptions.addedSchedules.indexOf(element.description) === -1){
                cancelledTicketOptions.addedSchedules.push(element.description);
                cancelledTicketOptions.scheduleOptions.push({
                    text:element.description,
                    value:element.description
                }); 
            }
        });
    }

    return {
        confirmedTicketOptions,
        cancelledTicketOptions
    }
}


const generateJsonToExport=(filters,confirmedTickets,cancelledTickets,transactionDetailsByTicketId)=>{

    let reportsConfirmedXmlData=[];
    let reportsCancelledXmlData=[];

    if(isValidArray(confirmedTickets)&&confirmedTickets.length>0){
        confirmedTickets.forEach(element => {
            let bookingTIme=getLocalDateAndTime(element.booking_time);
            let startDate =getLocalDate(convertDateStringToDate(element.start_date.split('T')[0]));
            let amountPaid =roundNumber(isValidNumber(element.amount_paid)?element.amount_paid : element.total_ticket_cost);
            let orderNo = '';
            if(isValid(transactionDetailsByTicketId)&&isValid(transactionDetailsByTicketId[element.ticket_id])){
                let transactionIds = []
                if(isValid(transactionDetailsByTicketId[element.ticket_id])){
                    transactionDetailsByTicketId[element.ticket_id].forEach((transaction) => {
                        transactionIds.push(transaction.order_no);
                    });
                }
                orderNo = transactionIds.join(', ');
            }
            reportsConfirmedXmlData.push([
                element.pnr,element.seat_count,
                element.seat_number,
                element.total_ticket_cost,element.direct_discount,amountPaid,element.commission,
                roundNumber(amountPaid-element.commission),
                bookingTIme,startDate,element.description,orderNo
            ])
        });
    }

    if(isValidArray(cancelledTickets)&&cancelledTickets.length>0){
        cancelledTickets.forEach(element => {
            
            let bookingTIme=getLocalDateAndTime(element.booking_time);
            let startDate =getLocalDate(convertDateStringToDate(element.start_date.split('T')[0]));
            
            let amountPaid =roundNumber(isValidNumber(element.amount_paid)?element.amount_paid:element.total_ticket_cost);
            let refund =  roundNumber(amountPaid-element.cancellation_penalty);
            let orderNo = '';
            if(isValid(transactionDetailsByTicketId)&&isValid(transactionDetailsByTicketId[element.ticket_id])){
                let transactionIds = []
                if(isValid(transactionDetailsByTicketId[element.ticket_id])){
                    transactionDetailsByTicketId[element.ticket_id].forEach((transaction) => {
                        transactionIds.push(transaction.order_no);
                    });
                }
                orderNo = transactionIds.join(', ');
            }

            reportsCancelledXmlData.push([
                element.pnr,element.seat_count,
                element.seat_number,
                element.total_ticket_cost,element.direct_discount,amountPaid,element.commission,element.cancellation_penalty,
                refund,bookingTIme,startDate,element.description,orderNo
            ])
        });
    }

    let dateType =filters.isBookingDate?"Booking":"Travel";
    let generatedTime = getLocalDateAndTime(new Date());


        var worksheet = XLSX.utils.aoa_to_sheet([
            [], // A1
            [], // A2
            ["Report","From Date", "To Date","Type of date" , "Generated day/time"], // A3
            ["Web ticket sales report",filters.fromDate,filters.toDate,dateType,generatedTime],
            [],
            [],
            [
                "PNR" , "Seat count" ,
                "Seat number" ,
                "Total amount","Discount","Amount paid","Commission","Net amount",
                "Booking time","Travel date","Trip description","Transaction details"
            ],
            ...reportsConfirmedXmlData,
            [],
            [],
            ["Cancelled tickets"],
            [
                "PNR" , "Seat count" ,
                "Seat number" ,
                "Total amount","Discount" ,"Cancelled amount","Commission","Cancellation penality" ,
                "Refund","Booking time","Travel date","Trip description","Cancelled date","Transaction details"
            ],
            ...reportsCancelledXmlData
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Web Ticket Sales Report');
        XLSX.writeFile(workbook, 'web-ticket-sales-report.xlsx');
}


const getTicketsByAgentName=(tickets,agentName,isSelectAllAgents)=>{
    let formatedTickets=[];
    let seatCount = 0,
    totalTicketCost = 0,
    directDiscount = 0,
    totalCommission = 0,
    amountPaid = 0,
    cancellationPenalty = 0,
    totalnetAmount = 0;

    tickets.forEach(element => {
        if(isSelectAllAgents||(isValid(agentName)&&element.name===agentName)){
            seatCount=seatCount+element.seat_count;
            totalTicketCost = totalTicketCost + element.total_ticket_cost;
            directDiscount = directDiscount + element.direct_discount;
            cancellationPenalty = cancellationPenalty +element.cancellation_penalty;

            amountPaid = amountPaid + roundNumber(isValidNumber(element.amount_paid)?element.amount_paid:element.total_ticket_cost);
            totalCommission = element.commission + totalCommission;
            formatedTickets.push(element);
        }
    });
    return {dataSource:formatedTickets,total:{
        seatCount,
        totalTicketCost,
        directDiscount,
        totalCommission,
        amountPaid,
        cancellationPenalty,
        totalnetAmount:roundNumber(amountPaid-totalCommission),
        refundAmount:amountPaid-cancellationPenalty
    }};
}

const RenderReport=({fromDate,toDate,isBookingDate,agentName,confirmedTickets,cancelledTickets,pagination,isSelectAllAgents,transactionDetailsByTicketId})=>{

    let {
        confirmedTicketOptions,
        cancelledTicketOptions
    } = getFilteredOptions(confirmedTickets,cancelledTickets);


    const [confirmPage, setConfirmPage] = useState(1);
    const [cancelPage, setCancelPage] = useState(1);
    const [confirmPaginationSize, setConfirmPaginationSize] = useState(getDefaultPageSize);
    const [cancelPaginationSize, setCancelPaginationSize] = useState(getDefaultPageSize);

    const confirmTicketsColumns=[
        {
            title:'SN',
            key:'index',
            render : (text, record, index) => (confirmPage - 1) * confirmPaginationSize + index+1
        },
        {
            title:'Agent Name',
            key:'name',
            dataIndex:'name'
        },
        {
            title:'PNR',
            key:'pnr',
            dataIndex : 'pnr'
        },
        {
            title:'Seat count',
            key:'seat_count',
            dataIndex : 'seat_count'
        },
        {
            title:'Seat number',
            key:'seat_number',
            dataIndex : 'seat_number'
        },
        {
            title:'Total amount',
            key:'total_ticket_cost',
            dataIndex : 'total_ticket_cost'
        },
        {
            title:'Discount',
            key:'direct_discount',
            dataIndex : 'direct_discount'
        },
        {
            title:'Amount paid',
            key:'amountPaid',
            render : (text, record, index) => roundNumber(isValidNumber(record.amount_paid)?record.amount_paid:record.total_ticket_cost)
        },
        {
            title:'Commission inc. GST',
            key:'commission',
            dataIndex : 'commission'
        },
        {
            title:'Net amount',
            key:'net_amount',
            render : (text, record, index) => {
                const amountPaid = isValidNumber(record.amount_paid) ? record.amount_paid : record.total_ticket_cost;
                const commission = isValidNumber(record.commission) ? record.commission : 0;
                return roundNumber(amountPaid - commission);
            }
        },
        {
            title:'Booking time',
            key:'booking_time',
            render : (text, record, index) => getLocalDateAndTime(record.booking_time)
        },
        {
            title:'Travel date',
            key:'pnr',
            render : (text, record, index) => {
                if(isValid(record.start_date)){
                    return getLocalDate(convertDateStringToDate(record.start_date.split('T')[0]))
                }else{
                    return ''
                }
            }
        },
        {
            title:'Trip description',
            key:'description',
            dataIndex : 'description',
            filters:confirmedTicketOptions.scheduleOptions,
            onFilter: (value, record) => record.description.indexOf(value) === 0
        },
        {
            title:"Transaction details",
            key:'ticket_id',
            dataIndex : 'ticket_id',
            render : (text, record, index) => {
                if(isValid(text)&&isValid(transactionDetailsByTicketId)&&isValid(transactionDetailsByTicketId[text])){
                    let transactionIds = []
                    if(isValid(transactionDetailsByTicketId[text])){
                        transactionDetailsByTicketId[text].forEach((transaction) => {
                            transactionIds.push(transaction.order_no);
                        });
                    }
                    return transactionIds.join(', ');
                }else{
                    return ''
                }
            }
        }
    ];

    if(dafidyUserCheck()){
        confirmTicketsColumns.push({
            title : "Operator name",
            key : "operator_name",
            dataIndex : "operator_name",
            filters:confirmedTicketOptions.operatorOptions,
            onFilter: (value, record) => record.operator_name.indexOf(value) === 0,
        })
    }

    const cancelTicketsColumns=[
        {
            title:'SN',
            key:'index',
            render : (text, record, index) => (cancelPage - 1) * cancelPaginationSize + index+1
        },
        {
            title:'Agent Name',
            key:'name',
            dataIndex:'name'
        },
        {
            title:'PNR',
            key:'pnr',
            dataIndex : 'pnr'
        },
        {
            title:'Seat count',
            key:'seat_count',
            dataIndex : 'seat_count'
        },
        {
            title:'Seat number',
            key:'seat_number',
            dataIndex : 'seat_number'
        },
        {
            title:'Total amount',
            key:'total_ticket_cost',
            dataIndex : 'total_ticket_cost'
        },
        {
            title:'Discount',
            key:'direct_discount',
            dataIndex : 'direct_discount'
        },
        {
            title:'Cancelled amount',
            key:'amountPaid',
            render : (text, record, index) => roundNumber(isValidNumber(record.amount_paid)?record.amount_paid:record.total_ticket_cost)
        },
        {
            title:'Commission inc. GST',
            key:'commission',
            dataIndex : 'commission'
        },
        {
            title:'Penality',
            key:'cancellation_penalty',
            dataIndex : 'cancellation_penalty'
        },
        {
            title:'Refund amount',
            key:'net_amount',
            render : (text, record, index) =>{
                let amountPaid =isValidNumber(record.amount_paid)?record.amount_paid:record.total_ticket_cost;
                return roundNumber(amountPaid-record.cancellation_penalty)
                }
        },
        {
            title:'Booking time',
            key:'booking_time',
            render : (text, record, index) => getLocalDateAndTime(record.booking_time)
        },
        {
            title:'Travel date',
            key:'pnr',
            render : (text, record, index) => {
                if(isValid(record.start_date)){
                    return getLocalDate(convertDateStringToDate(record.start_date.split('T')[0]))
                }else{
                    return ''
                }
            }
        },
        {
            title:'Trip description',
            key:'description',
            dataIndex : 'description',
            filters:cancelledTicketOptions.scheduleOptions,
            onFilter: (value, record) => record.description.indexOf(value) === 0
        },
        {
            title:'Cancelled date',
            key:'cancellation_time',
            render : (text, record, index) => {
                if(isValid(record.cancellation_time)){
                    return getLocalDate(convertDateStringToDate(record.cancellation_time.split('T')[0]))
                }else{
                    return ''
                }
            }
        },
        {
            title:"Transaction details",
            key:'ticket_id',
            dataIndex : 'ticket_id',
            render : (text, record, index) => {
                if(isValid(text)&&isValid(transactionDetailsByTicketId)&&isValid(transactionDetailsByTicketId[text])){
                    let transactionIds = []
                    if(isValid(transactionDetailsByTicketId[text])){
                        transactionDetailsByTicketId[text].forEach((transaction) => {
                            transactionIds.push(transaction.order_no);
                        });
                    }
                    return transactionIds.join(', ');
                }else{
                    return ''
                }
            }
        },
        {
            title:"Automatic refund",
            key:'automatic_refund',
            dataIndex : 'automatic_refund',
            render : (text, record, index) => {
                return record.automatic_refund === 1? 'Yes': 'No'
            }
        }
    ];

    if(dafidyUserCheck()){
        cancelTicketsColumns.push({
            title : "Operator name",
            key : "operator_name",
            dataIndex : "operator_name",
            filters:cancelledTicketOptions.operatorOptions,
            onFilter: (value, record) => record.operator_name.indexOf(value) === 0
        })
    }
    let dataSource = {
        confirmed:{
            ...getTicketsByAgentName(confirmedTickets,agentName,isSelectAllAgents)
        },
        cancelled:{
            ...getTicketsByAgentName(cancelledTickets,agentName,isSelectAllAgents)
        }
    }

    return(
        <div>
            <Row justify="center" gutter={[16,16]}>
                <Col>
                    <Text strong>Web ticket sales report</Text>
                </Col>
            </Row>
            <Row gutter={[16,0]} justify={"space-between"}>
                <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>From date : </Text>{fromDate}
                    </Text>
                </Col>
                <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>To date : </Text>{toDate}
                    </Text>
                </Col>
            </Row>
            <Row gutter={[16,0]} justify={"space-between"}>
                <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>Type of date : </Text>{isBookingDate?"Booking Date":"Travel Date"}
                    </Text>
                </Col>
                <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                            <Text strong>Generated day/time : </Text>{getLocalDateAndTime(new Date())}
                    </Text>
                </Col>
            </Row>
            <Row gutter={[16,0]}>
                <Col>
                    <Text strong>Agent : {isSelectAllAgents?"All agents":agentName}</Text>
                </Col>
            </Row>
           <Row gutter={[16,16]} className="marginTop">
               <Col>
                <Table  
                        columns={confirmTicketsColumns}
                        dataSource={dataSource.confirmed.dataSource}
                        pagination={getPaginationDetails(pagination,setConfirmPage, confirmPaginationSize, setConfirmPaginationSize)}
                        className="bordered-table"
                        summary={(pageData ) => {
                            if(isValidArray(dataSource.confirmed.total)){
                                return (
                                    <>
                                      <Table.Summary.Row>
                                        <Table.Summary.Cell>Total</Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell>{dataSource.confirmed.total.seatCount}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.confirmed.total.totalTicketCost)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.confirmed.total.directDiscount)}</Table.Summary.Cell>
                                        <Table.Summary.Cell className="fontWeightBold">{roundNumber(dataSource.confirmed.total.amountPaid)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.confirmed.total.totalCommission)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.confirmed.total.totalnetAmount)}</Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        {dafidyUserCheck()&&
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        }
                                      </Table.Summary.Row>
                                    </>
                                  );
                            }else{
                                return null;
                            }
                        }}
                    />
               </Col>
           </Row>
           <Row gutter={[16,16]} className="marginTop">
               <Col>
                <Table  
                        columns={cancelTicketsColumns}
                        dataSource={dataSource.cancelled.dataSource}
                        pagination={getPaginationDetails(pagination,setCancelPage, cancelPaginationSize, setCancelPaginationSize)}
                        className="bordered-table"
                        summary={(pageData ) => {
                            if(isValidArray(dataSource.confirmed.total)){
                                return (
                                    <>
                                      <Table.Summary.Row>
                                        <Table.Summary.Cell>Total</Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell>{dataSource.cancelled.total.seatCount}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.cancelled.total.totalTicketCost)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.cancelled.total.directDiscount)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.cancelled.total.amountPaid)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.cancelled.total.totalCommission)}</Table.Summary.Cell>
                                        <Table.Summary.Cell>{roundNumber(dataSource.cancelled.total.cancellationPenalty)}</Table.Summary.Cell>
                                        <Table.Summary.Cell className="fontWeightBold">{roundNumber(dataSource.cancelled.total.refundAmount)}</Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        {dafidyUserCheck()&&
                                        <Table.Summary.Cell></Table.Summary.Cell>
                                        }
                                      </Table.Summary.Row>
                                    </>
                                  );
                            }else{
                                return null;
                            }
                        }}
                    />
               </Col>
           </Row>
        </div>
    )
}

export const WebSalesTicketReport = () => {

    const [form] = Form.useForm();

    const [showReport,setShowReport]=useState(false);

    const dispatch = useDispatch();

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const [filters,setFilters]=useState({
        fromDate:undefined,
        toDate:undefined,
        isSelectAllAgents:true,
        isSelectAllSchedules:false,
        agentNames:[],
        schedules:[],
        operators:[]
    });

    const [cancelledTickets,setCancelledTickets]=useState(undefined);
    const [confirmedTickets,setConfirmedTickets]=useState(undefined);

    const [transactionDetailsByTicketId,setTransactionDetailsByTicketId]=useState(undefined);

    const onFinish=(values)=>{
        setLoading(true);
        let {
            dateRange,
            isBooking
        }=values;
        const fromDate = getAPIDateFormat(dateRange[0]);
        const toDate = getAPIDateFormat(dateRange[1]);
        setShowReport(false);
        filters.fromDate=fromDate;
        filters.toDate=toDate;
        filters.isBookingDate=isBooking;
        setFilters({...filters});
        fetchWebTicketSalesSheet(null,fromDate,toDate,isBooking,(data,)=>{
        setCancelledTickets(data.cancelledTransactions);
        setConfirmedTickets(data.confirmedTransactions);
        setTransactionDetailsByTicketId(data.transactionDetailsByTicketId);
        setShowReport(true);
        setLoading(false);
        },()=>{
            setLoading(false);
        });
    }


    return (
            <div className="report-inner-div">
                <Form
                    onFinish={onFinish}
                    form={form}
                    >
                    <Row gutter={[16,16]}>
                        <Col>
                            <Form.Item name="dateRange" label="Date range"
                            rules={[
                                { required: true , message: 'Please input your date range!'},
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (!value || (value[1].diff(value[0],"days") <= allowedMaxDaysRange)) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(new Error(`Please select a date range with in ${allowedMaxDaysRange} days`));
                                    },
                                  })
                            ]}>
                                    <RangePicker
                                        ranges={getRangeOptions(allowedMaxDaysRange)}
                                    />
                            </Form.Item>
                        </Col>
                        <Col>
                        <Form.Item name="isBooking" label="" rules={[{ required: true , message: 'Please select any option!'}]}>
                            <Radio.Group>
                                <Radio value={true}>Booking Date</Radio>
                                <Radio value={false}>Travel Date</Radio>
                            </Radio.Group>
                        </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item>
                                <Button htmlType="submit">Search</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {showReport&&
                <div>
                    <Row gutter={16}>
                        <Col>
                          <Button onClick={()=>{
                            generateJsonToExport(filters,confirmedTickets,cancelledTickets,transactionDetailsByTicketId);
                            }}>Export</Button>
                        </Col>
                        <Col>
                                <Printer
                                    showComponent={false}
                                    zoomValue={0.5}
                                    renderComponent={()=>{
                                        return (
                                        <RenderReport
                                            fromDate={filters.fromDate}
                                            toDate={filters.toDate}
                                            isBookingDate={filters.isBookingDate}
                                            agentName={filters.agentName}
                                            isSelectAllAgents={filters.isSelectAllAgents}
                                            confirmedTickets={confirmedTickets}
                                            transactionDetailsByTicketId={transactionDetailsByTicketId}
                                            cancelledTickets={cancelledTickets}
                                            pagination={false}
                                        />
                                )
                            }} />
                        </Col>
                    </Row>
                    <RenderReport
                        fromDate={filters.fromDate}
                        toDate={filters.toDate}
                        isBookingDate={filters.isBookingDate}
                        agentName={filters.agentName}
                        isSelectAllAgents={filters.isSelectAllAgents}
                        confirmedTickets={confirmedTickets}
                        transactionDetailsByTicketId={transactionDetailsByTicketId}
                        cancelledTickets={cancelledTickets}
                        pagination={true}
                    />
                </div>
                }
            </div>
    )
}
